/** Primary strip shown on first reaction click (keep short). */
export const CHAT_REACTION_QUICK_EMOJIS = [
  '👍',
  '❤️',
  '😂',
  '😊',
  '🎸',
  '🔥',
  '🎉',
  '🙏',
] as const;

/** Double-click on a message toggles this reaction. */
export const CHAT_REACTION_DOUBLE_CLICK_EMOJI = '💜';

/** Short meaning labels for quick-reaction tooltips / a11y. */
export const CHAT_REACTION_EMOJI_LABELS: Record<
  (typeof CHAT_REACTION_QUICK_EMOJIS)[number],
  { key: string; defaultLabel: string }
> = {
  '👍': { key: 'chat.timeline.reactionAgree', defaultLabel: 'Agree' },
  '❤️': { key: 'chat.timeline.reactionLove', defaultLabel: 'Love' },
  '😂': { key: 'chat.timeline.reactionFunny', defaultLabel: 'Funny' },
  '😊': { key: 'chat.timeline.reactionHappy', defaultLabel: 'Happy' },
  '🎸': { key: 'chat.timeline.reactionGuitar', defaultLabel: 'Guitar' },
  '🔥': { key: 'chat.timeline.reactionAwesome', defaultLabel: 'Awesome' },
  '🎉': { key: 'chat.timeline.reactionCelebrate', defaultLabel: 'Celebrate' },
  '🙏': { key: 'chat.timeline.reactionThanks', defaultLabel: 'Thanks' },
};

export interface ChatEmojiCategory {
  id: string;
  labelKey: string;
  defaultLabel: string;
  emojis: readonly string[];
}

export const CHAT_EMOJI_CATEGORIES: readonly ChatEmojiCategory[] = [
  {
    id: 'music',
    labelKey: 'chat.timeline.emojiCategoryMusic',
    defaultLabel: 'Music',
    emojis: ['🎵', '🎶', '🎸', '🎹', '🥁', '🎤', '🎧', '🎼', '🎻', '🪕', '🎺', '🎷', '🪗', '🎭', '🎬', '📻', '🔊', '🎙️', '🕺', '💃'],
  },
  {
    id: 'smileys',
    labelKey: 'chat.timeline.emojiCategorySmileys',
    defaultLabel: 'Smileys',
    emojis: ['😀', '😃', '😄', '😁', '😅', '😂', '🤣', '🙂', '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😋', '😎', '🤔', '😴', '😢', '😭', '😤', '😱', '🥳'],
  },
  {
    id: 'gestures',
    labelKey: 'chat.timeline.emojiCategoryGestures',
    defaultLabel: 'Gestures',
    emojis: ['👍', '👎', '👏', '🙌', '🤝', '🙏', '💪', '✌️', '🤞', '👋', '🫶', '👌', '🤘', '🫡', '✅', '❌', '❓', '❗', '💯', '🔥'],
  },
  {
    id: 'hearts',
    labelKey: 'chat.timeline.emojiCategoryHearts',
    defaultLabel: 'Hearts',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '✨'],
  },
] as const;
